import React from "react";
import PropTypes from "prop-types";
import "./penaltysettingsmodal.css";


const PenaltySettingsModal = (props) => {
  const handleSave = (val) => {
    props.onBackdropPress();
    console.log("Navigating to:", val);
    if (val === "personal") {
      props.navigation.push("/PersonalFoulSettings");
    }
    if (val === "technical") {
      props.navigation.push("/TechnicalFoulSettings");
    }
    if (val === "time") {
      props.navigation.push("/PenaltyTimingSettings");
    }
  };

  return (
    props.visible && (
      <div className="overlay-penalty-settings">
        <div
          className="backdrop-penalty-settings"
          onClick={props.onBackdropPress}
        ></div>

        <div className="modal-container-penalty-settings">
          <h2 className="modal-title-penalty-settings">
            Penalty Time & Descriptions
          </h2>
          <button
            className="modal-btn-penalty-settings"
            onClick={() => handleSave("technical")}
          >
            Technical Fouls
          </button>
          <button
            className="modal-btn-penalty-settings"
            onClick={() => handleSave("personal")}
          >
            Personal Fouls
          </button>
          <button
            className="modal-btn-penalty-settings"
            onClick={() => handleSave("time")}
          >
            Penalty Times
          </button>
        </div>
      </div>
    )
  );

};

export default PenaltySettingsModal;